<article class="detail-layout" [innerHTML]="'Core.Toegankelijkheidsverklaring' | translate">
</article>
